import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import ExportUser from "./ExportUser";

const UserPengguna = () => {
  const [adminList, setAdminList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [meta, setMeta] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
  });

  const fetchAdmin = async (page = 1) => {
    setLoading(true);
    try {
      const token = Cookies.get("token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/user-all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          search: search || "",
          page,
          per_page: meta.per_page,
        },
      });

      // Sesuai struktur response contoh kamu
      setAdminList(res.data.data || []);
      setMeta(res.data.meta || meta);
    } catch (err) {
      console.error("Gagal ambil data user:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch saat pertama kali & saat search berubah
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchAdmin(1);
    }, 400); // debounce biar nggak spam request saat ketik

    return () => clearTimeout(delayDebounce);
  }, [search]);

  return (
    <div className="overflow-x-auto mt-7">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Daftar Pengguna (Masyarakat)</h2>
        <div className="flex gap-4 items-center">
          Total Pengguna: {meta.total}
          <input type="text" placeholder="Cari nama atau email..." value={search} onChange={(e) => setSearch(e.target.value)} className="border px-3 py-2 rounded-lg text-sm" />
          <ExportUser data={adminList} />
        </div>
      </div>

      <table className="min-w-full border border-gray-300 text-sm md:text-base rounded-lg">
        <thead className="bg-primary text-black2">
          <tr>
            <th className="p-2 text-left">No</th>
            <th className="p-2 text-left">Nama</th>
            <th className="p-2 text-left">Email</th>
            <th className="p-2 text-left">No Telepon</th>
            <th className="p-2 text-left">Tanggal Daftar</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={6} className="text-center p-4">
                <div className="flex justify-center items-center h-40">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
                </div>
              </td>
            </tr>
          ) : adminList && adminList.length > 0 ? (
            adminList.map((item: any, index: number) => (
              <tr key={item.id} className="border-b hover:bg-gray-100">
                <td className="p-2">{(meta.current_page - 1) * meta.per_page + index + 1}</td>
                <td className="p-2">{item.name}</td>
                <td className="p-2">{item.email}</td>
                <td className="p-2">{item.no_tlpn || "-"}</td>
                <td className="p-2">
                  {item.created_at
                    ? new Date(item.created_at).toLocaleDateString("id-ID", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })
                    : "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center p-4"></td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-end items-center mt-4 text-sm">
        <div className="flex gap-2">
          <button disabled={meta.current_page === 1} onClick={() => fetchAdmin(meta.current_page - 1)} className={`px-3 py-1 rounded border ${meta.current_page === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}>
            Prev
          </button>
          <button className="text-xs">
            {meta.current_page} of {meta.last_page}
          </button>
          <button
            disabled={meta.current_page === meta.last_page}
            onClick={() => fetchAdmin(meta.current_page + 1)}
            className={`px-3 py-1 rounded border ${meta.current_page === meta.last_page ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserPengguna;
